import React, { useState } from 'react';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import '@progress/kendo-theme-default/dist/all.css';
import { Pagination } from 'antd';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import BalanceTable from './Common/BalanceTable';
import SelectList from './Common/SelectList';
import SearchBtn from './Common/SearchBtn';
import ConvertButtons from './Common/ConvertButtons';

const RemainingBalance = ({ isShow, setIsShow }) => {
    const balanceTable = [];

    const [data, setData] = useState(balanceTable);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const dataRef = React.createRef();

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <div className='page_first_div '>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>Remaining Balance Details</p>
                <section className='page_section min-h-[23rem]'>

                    {/* Selectors,Inputs,SearchBar */}
                    <form className='flex flex-col justify-center px-4 xsm:px-8 lg:flex-row 2xl:justify-start items-center flex-wrap gap-4 py-4 '>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Package Group--</option>
                                <option value="Fitness" >Fitness</option>
                                <option value="BuildUp">BuildUp</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Package--</option>
                                <option value="Weight Loss" >Weight Loss</option>
                                <option value="Weight Gain">Weight Gain</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector  w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Member--</option>
                                <option value="Maria">Maria</option>
                                <option value="Hemant">Hemant</option>
                                <option value="Rajiv">Rajiv</option>
                                <option value="Sharan">Sharan</option>
                            </select>
                        </div>
                        <div className='font-lato text-sm xsm:text-base w-full lg:w-80'>
                            <DatePicker placeholder='Start/Expiry Date' format="dd MMMM yyyy" className="date_picker" />
                        </div>
                        <SearchBtn
                            setSearchTerm={setSearchTerm}
                        />
                    </form>

                    {/* show option and convert buttons */}
                    <div className='pt-2 flex flex-col gap-4 justify-center md:justify-between px-4 xsm:px-8 md:flex-row'>
                        <SelectList
                            setPostPerPage={setPostPerPage}
                            data={data}
                        />
                        <ConvertButtons
                            data={data}
                            ref={dataRef}
                        />
                    </div>

                    {/* Balance Table */}
                    <BalanceTable
                        data={currentPost}
                        sortData={data}
                        setData={setData}
                        searchTerm={searchTerm}
                        ref={dataRef}
                    />

                    {/* Showing table length with Pagination */}
                    <div className='px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>
                        <Pagination
                            total={data.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default RemainingBalance;